export const ActionTypes = {
  GET_REPORTING_LIST: 'GET_REPORTING_LIST',
};
